/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Row, Col } from 'react-bootstrap';
import {
  useForm,
  FieldValues,
  SubmitHandler,
  Controller
} from 'react-hook-form';
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { useTranslation } from 'react-i18next';

import Button from 'components/base/Button';
import { showAlert } from 'store/alert/alert.thunk';
import installmentReportsService from 'service/installmentReports';

interface UpdatePaymentInstallmentReportProps {
  refetch?: any;
  selectedPid?: any;
  setSelectedPid?: any;
  setShowModal: (show: boolean) => void;
  selectedObjectItem?: any;
  setSelectedObjectItem?: any;
  setUpdatePaymentBox: any;
}

const UpdatePaymentInstallmentReport = ({
  selectedObjectItem,
  setSelectedObjectItem,
  refetch,
  selectedPid,
  setSelectedPid,
  setShowModal,
  setUpdatePaymentBox
}: UpdatePaymentInstallmentReportProps) => {
  const { t } = useTranslation();
  const dispatch: Dispatch<any> = useDispatch();
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm();

  const inputRef = useRef<HTMLInputElement | any>();

  const onSubmit: SubmitHandler<FieldValues> = data => {
    if (+data?.quantity === 0) {
      dispatch(
        showAlert({
          title: t('quantity_cannot_thero')
        })
      );
      return;
    }

    createData(data);
  };

  const createData = (data: any) => {
    setLoading(true);

    if (+selectedObjectItem?.price < +data?.quantity) {
      dispatch(
        showAlert({
          title: `${t('quantity_exceeds_remainder')}`
        })
      );
      setLoading(false);

      return;
    }
    const createdData = {
      amount: +data?.quantity
    };

    if (selectedPid !== null) {
      installmentReportsService
        .updateInstallmentItem(selectedPid, createdData)
        .then((res: any) => {
          if (res) {
            dispatch(
              showAlert({
                title: `${t('successfully_added')}`,
                type: 'success'
              })
            );
            refetch();
            setLoading(false);
            setUpdatePaymentBox(true);
          }
        });
    }
    setShowModal(false);
    setSelectedPid(null);
    setSelectedObjectItem({});
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef.current]);

  return (
    <div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="mb-3">
          <Col>
            <Controller
              name={`quantity`}
              control={control}
              rules={{
                required: true,
                validate: value => {
                  const num = parseFloat(value);
                  return (
                    (!isNaN(num) && num > 0) ||
                    t('quantity_must_be_valid_number')
                  );
                }
              }}
              render={({ field }) => (
                <Form.Floating className="md-4">
                  <Form.Control
                    {...field}
                    ref={inputRef}
                    type="number"
                    step="0.1"
                    min="0.1"
                    placeholder={t('quantity')}
                    onFocus={e => e.target.select()}
                    isInvalid={!!errors.quantity}
                  />
                  <label htmlFor="floatingInputCustom">{t('quantity')}</label>
                  {errors.quantity && (
                    <Form.Control.Feedback type="invalid">
                      {t('required_field')}
                    </Form.Control.Feedback>
                  )}
                </Form.Floating>
              )}
            />
          </Col>
        </Row>

        <Button
          className="w-100"
          variant="primary"
          type="submit"
          loading={loading}
        >
          {t('add')}
        </Button>
      </Form>
    </div>
  );
};

export default UpdatePaymentInstallmentReport;
